var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    id: "layers_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layers"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 128.626,
    x2: 383.3489,
    y1: 329.5313,
    y2: 182.4669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F14D5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1309,
    style: {
      stopColor: "#F05454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3346,
    style: {
      stopColor: "#ED663E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#ED683C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    style: {
      stopColor: "#F3903F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDC70C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.665,189.757l-95.77-95.77c-9.057-9.057-21.1-14.045-33.908-14.045   c-12.809,0-24.852,4.988-33.908,14.045l-95.771,95.77c-18.183,18.183-18.678,47.45-1.497,66.244   c-17.18,18.792-16.685,48.056,1.496,66.238l95.771,95.77c9.06,9.061,21.103,14.051,33.91,14.051c12.807,0,24.85-4.99,33.91-14.051   l95.77-95.77c9.056-9.055,14.043-21.096,14.043-33.906c0-12.082-4.442-23.48-12.547-32.334   C404.343,237.204,403.847,207.939,385.665,189.757z M133.379,196.828l95.771-95.77c7.169-7.169,16.7-11.117,26.838-11.117   c10.137,0,19.668,3.948,26.837,11.117l95.77,95.77c14.798,14.798,14.798,38.877,0,53.675l-95.77,95.77   c-7.169,7.168-16.7,11.117-26.837,11.117c-10.138,0-19.669-3.949-26.838-11.117l-95.771-95.77   C118.582,235.705,118.582,211.626,133.379,196.828z M378.598,315.168l-95.77,95.77c-7.172,7.172-16.703,11.121-26.839,11.121   c-10.137,0-19.669-3.949-26.84-11.121l-95.771-95.77c-14.268-14.27-14.771-37.162-1.523-52.047l90.225,90.223   c9.057,9.059,21.1,14.047,33.908,14.047c12.808,0,24.851-4.988,33.908-14.047l90.225-90.225c6.197,6.953,9.591,15.82,9.591,25.213   C389.711,298.471,385.764,308,378.598,315.168z",
    fill: "url(#SVGID_1_)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.a20a04347cb7e8150465e80aef06a266.svg";
export { ForwardRef as ReactComponent };